import { loadStripe } from '@stripe/stripe-js'

const Settings = require('settings.json')
const currentProcess = process.env.REACT_APP_MODE
  ? process.env.REACT_APP_MODE
  : process.env.NODE_ENV

const publishableKey = Settings[currentProcess].stripe.publishableAPIKey

let cachedStripePromise

if (typeof window !== 'undefined') {
  if (!window.__ELEO_STRIPE_PROMISE__) {
    window.__ELEO_STRIPE_PROMISE__ = loadStripe(publishableKey)
  }
  cachedStripePromise = window.__ELEO_STRIPE_PROMISE__
} else {
  cachedStripePromise = loadStripe(publishableKey)
}

export const stripePromise = cachedStripePromise
